import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import AppContext from "../AppContext";

function Button({ label, iconSrc, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex-col w-64 h-32 border-2 hover:border-blue-700 border-zinc-800 rounded-lg flex justify-center items-center bg-zinc-900 hover:text-white hover:bg-gradient-to-b from-blue-700 to-zinc-900 gap-3"
    >
      <img src={iconSrc} alt={label} className="h-12 text-white" />
      {label}
    </button>
  );
}

const Settings = () => {
  const defaultSettings = [
    {
      label: "Camera Master",
      iconSrc: "camera-icon.svg",
      route: "/cameras",
      enabledRoles: [100],
    },
    {
      label: "User Master",
      iconSrc: "profile-user.svg",
      route: "/users",
      enabledRoles: [100, 200],
    },
    {
      label: "Alarm Master",
      iconSrc: "alarm-icon.svg",
      route: "/alarms",
      enabledRoles: [100],
    },
    {
      label: "Model Master",
      iconSrc: "model.svg",
      route: "/models",
      enabledRoles: [100],
    },
    {
      label: "Model Template Master",
      iconSrc: "model.svg",
      route: "/modelTemplates",
      enabledRoles: [100],
    },
    {
      label: "Turn Server Master",
      iconSrc: "model.svg",
      route: "/turnServers",
      enabledRoles: [100],
    },
  ];
  const { authCtx } = useContext(AppContext);

  const navigate = useNavigate();

  return (
    <div className="text-white flex flex-col gap-3 lg:ml-[33%] md:ml-[20%] ml-[10%] items-start h-full">
      {/* <div className="flex flex-col text-white font-semibold text-base gap-4 w-fit justify-center h-full"> */}
      <div className="flex gap-5 justify-between w-full pr-[10%] pt-10">
        <div className="grid grid-cols-2 gap-4 h-full flex-shrink-0">
          {defaultSettings.map((ds, index) => (
            <Button
              key={index}
              label={ds.label}
              iconSrc={ds.iconSrc}
              onClick={() => navigate(ds.route)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Settings;
